import { FormattedMessage } from 'react-intl';
import { useHistory } from 'react-router-dom';

import { ArrowBack } from '../../../design-system/Icons/ArrowBack';
import s from '../../../shared/components/layout/ContextualNavbar.css';
import { DEFAULT_VIEW_ROUTE } from '../../../shared/routing/Routes';

export const MessageTemplateNavbar = (): JSX.Element => {
    const history = useHistory();
    const hasNavigatedInRequestManager = history.action !== 'POP';
    return (
        <nav className={s.navbarContainer}>
            <div className={s.backContainer}>
                <a
                    data-testid="message-templates-navbar-back"
                    onClick={() =>
                        hasNavigatedInRequestManager
                            ? history.goBack()
                            : history.push(DEFAULT_VIEW_ROUTE)
                    }
                    className={s.backButton}
                >
                    <ArrowBack color="var(--ink)" fontSize="small" />
                    <p className={s.backLabel}>
                        <FormattedMessage id="global.back" />
                    </p>
                </a>
            </div>
        </nav>
    );
};
